import { AddressTypeEnum, type CustomerDTO } from './models';

/** Datos del receptor que el timbrado CFDI exige. */
export function missingCustomerInvoiceFields(customer: CustomerDTO | null | undefined): string[] {
  const missing: string[] = [];
  if (!customer) {
    return ['cliente'];
  }
  if (!customer.type) {
    missing.push('tipo de persona (física o moral)');
  }
  if (customer.taxRegime?.id == null && !customer.taxRegime?.code) {
    missing.push('régimen fiscal');
  }
  if (!customer.taxId?.trim()) {
    missing.push('RFC');
  }
  if (customer.country?.id == null) {
    missing.push('país');
  }
  const hasBillingAddress = (customer.addresses ?? []).some(
    (address) => address.type === AddressTypeEnum.BILLING && !!address.zipCode?.trim()
  );
  if (!hasBillingAddress) {
    missing.push('dirección de facturación');
  }
  return missing;
}

export function customerInvoiceReadinessMessage(missing: string[]): string {
  return `No se puede generar la factura automáticamente porque al cliente le faltan datos fiscales: ${missing.join(', ')}. Complétalos antes de continuar.`;
}
